/*
 * @Author: panweikang
 * @Date: 2025-02-19 15:52:22
 * @LastEditTime: 2025-04-20 12:15:49
 * @Description: 
 */

import React, { Component, useEffect, useState, useMemo, useRef } from "react";
import './index.scss'
import { connect } from 'react-redux';
import MTabBar from '../../../../../components/MTabBar';
import { Icon } from 'antd-mobile'
import zixunPng from '../../../../../images/mine/zixun.png'
import MFooter from "../../../../../components/MFooter";
import MHead from "../../../../../components/MHead";
import { CACHE_ACCESS_TOKEN, CACHE_SESSION_USER } from "../../../../../constants/Profile";
import HttpUtils from "../../../../../utils/HttpUtils";
import { InfoCenterListAPI } from "../../../WebService";
import moment from 'moment'
import { DateTimeFormat } from "../../../../../utils/DateUtil";
import debounce from "lodash.debounce";

const InfoCenterList = ({ dispatch, router }) => {

  const token = localStorage.getItem(CACHE_ACCESS_TOKEN)
  const user = JSON.parse(localStorage.getItem(CACHE_SESSION_USER))

  const [loading, setLoading] = useState(false)
  const [hasMore, setHasMore] = useState(true)

  const InfoCenterListRef = useRef(null)

  // 滚动处理
  const handleScroll = useMemo(
    () =>
      debounce(() => {
        const scrollContainer = InfoCenterListRef.current
        if (!scrollContainer) return

        const { scrollTop, scrollHeight, clientHeight } = scrollContainer
        const isBottom = scrollHeight - scrollTop <= clientHeight + 1

        if (isBottom && !loading && hasMore) {
          setPage(prev => prev + 1)
        }
      }, 200),
    [loading, hasMore]
  )

  useEffect(() => {
    const scrollContainer = InfoCenterListRef.current
    if (!scrollContainer) return

    scrollContainer.addEventListener('scroll', handleScroll)
    return () => {
      scrollContainer.removeEventListener('scroll', handleScroll)
    }
  }, [handleScroll]);


  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(20)
  const [list, setList] = useState([])

  useEffect(() => {
    getInfoCenterList()
  }, [page])

  const getInfoCenterList = () => {
    if (loading || !hasMore) return
    setLoading(true)

    HttpUtils.get(`${InfoCenterListAPI}?channelCode=INFORMATION_CENTER&currentPage=${page}&pageSize=${pageSize}`, (res) => {
      setList(prev => page === 1 ? res.data : [...prev, ...res.data])
      setHasMore(res.data.length >= pageSize)
      setLoading(false)
    }, () => {
      setLoading(false)
    })
  }

  const handleClick = (id) => {
    router.navigate(`/articleDetails/${id}`)
  }

  return (
    <>
      {
        <div className="tabbarBottom InfoCenter">
          <MHead isBack={false} />
          <div className="InfoCenterList" ref={InfoCenterListRef}>
            {
              list.map((item, index) => {
                return (
                  <div key={item.id} className="InfoCenterListItem" onClick={() => { handleClick(item.id) }}>
                    <img src={item.titleImage + '?x-oss-process=style/Image_w300h300PNG'} alt="" />
                    <div>
                      <p>{item.title}</p>
                      <p>发布时间 {DateTimeFormat.dateToHyphenString(item.updateTime)}</p>
                    </div>
                  </div>
                )
              })
            }
          </div>
          {/* <MFooter /> */}
        </div>
      }
      <MTabBar router={router} index={3} />
    </>
  );
};


function mapStateToProps(store) {
  return {};
}


export default connect(mapStateToProps)(InfoCenterList);
